module.exports = __webpack_public_path__ + "img/tp-logo.f70527f3.png";